import { render, staticRenderFns } from "./RepairKitsDashboard.vue?vue&type=template&id=cff42d26&scoped=true&"
import script from "./RepairKitsDashboard.vue?vue&type=script&lang=js&"
export * from "./RepairKitsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff42d26",
  null
  
)

export default component.exports